import React, { useState, useEffect } from 'react';

const OperationModal = ({ isOpen, onClose, type, clients, onSubmit, posting, defaultClientId }) => {
  const [form, setForm] = useState({ clientId: '', description: '', poidsBrut: '', perte: '', poids750: '', dateSaisie: '' });
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const today = new Date().toISOString().split('T')[0];
      setForm({ clientId: defaultClientId || '', description: '', poidsBrut: '', perte: type === 'broutille' ? '15' : '', poids750: '', dateSaisie: today });
      setError('');
      const client = clients.find(c => String(c.id) === String(defaultClientId));
      setSearchTerm(client?.label || '');
      setShowDropdown(false);
    }
  }, [isOpen, defaultClientId, type, clients]);

  if (!isOpen) return null;

  const handleChange = (field, value) => {
    setForm(prev => {
      const updated = { ...prev, [field]: value };
      if (type === 'broutille' && (field === 'poidsBrut' || field === 'perte')) {
        const brut = parseFloat(field === 'poidsBrut' ? value : prev.poidsBrut) || 0;
        const perte = parseFloat(field === 'perte' ? value : prev.perte) || 0;
        if (brut > 0 && perte >= 0) {
          updated.poids750 = (brut * (1 - perte / 100)).toFixed(2);
        }
      }
      return updated;
    });
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setShowDropdown(true);
    if (!value) {
      handleChange('clientId', '');
    }
  };

  const handleSelectClient = (client) => {
    handleChange('clientId', client.id);
    setSearchTerm(client.label);
    setShowDropdown(false);
  };

  const handleClearClient = () => {
    handleChange('clientId', '');
    setSearchTerm('');
    setShowDropdown(false);
  };

  const filteredClients = clients.filter(c =>
    c.label.toLowerCase().includes(searchTerm.toLowerCase())
  ).slice(0, 50); // Limiter à 50 résultats pour performance

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    const requiredField = type === 'broutille' ? 'poidsBrut' : 'poids750';
    if (!form.clientId || !form[requiredField]) {
      setError('Client et poids requis');
      return;
    }
    const client = clients.find(c => String(c.id) === String(form.clientId));
    const payload = {
      clientId: client?.id,
      clientName: client?.label,
      description: form.description,
      poids750: parseFloat(form.poids750),
      dateSaisie: form.dateSaisie
    };
    if (type === 'broutille') {
      payload.perte = parseFloat(form.perte) || 0;
      payload.poids_brut = parseFloat(form.poidsBrut);
      payload.taux_perte = parseFloat(form.perte) || 0;
    }
    
    onSubmit(payload)
      .then(() => onClose())
      .catch(err => setError(err?.message || 'Erreur'));
  };

  const title = type === 'broutille' ? 'Entrée broutille' : 'Retour suite avoir';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }} onClick={onClose}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 8px 16px rgba(0,0,0,0.24)',
        width: '90%',
        maxWidth: '500px',
        maxHeight: '90vh',
        overflow: 'auto'
      }} onClick={(e) => e.stopPropagation()}>
        <div style={{ padding: '20px 24px', borderBottom: '1px solid #e0e0e0' }}>
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 500, color: '#202124' }}>{title}</h3>
        </div>
        
        <form onSubmit={handleSubmit} style={{ padding: '24px' }}>
          {error && (
            <div style={{ padding: '12px', marginBottom: '16px', backgroundColor: '#fce8e6', color: '#c5221f', borderRadius: '4px', fontSize: '14px' }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: '20px', position: 'relative' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#5f6368' }}>
              Client *
            </label>
            <div style={{ position: 'relative' }}>
              <input
                style={{
                  width: '100%',
                  padding: '10px 36px 10px 12px',
                  fontSize: '14px',
                  border: `1px solid ${form.clientId ? '#1a73e8' : '#dadce0'}`,
                  borderRadius: '4px',
                  backgroundColor: '#fff',
                  color: '#202124',
                  outline: 'none'
                }}
                type="text"
                value={searchTerm}
                onChange={(e) => handleSearchChange(e.target.value)}
                onFocus={() => setShowDropdown(true)}
                placeholder="Rechercher un client..."
                autoComplete="off"
                required
              />
              {form.clientId && (
                <button
                  type="button"
                  onClick={handleClearClient}
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    color: '#5f6368',
                    cursor: 'pointer',
                    fontSize: '20px',
                    padding: '4px 8px',
                    lineHeight: '1',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  title="Effacer"
                >
                  ×
                </button>
              )}
            </div>
            {showDropdown && searchTerm && filteredClients.length > 0 && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: '#fff',
                border: '1px solid #dadce0',
                borderRadius: '4px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                maxHeight: '200px',
                overflowY: 'auto',
                zIndex: 10,
                marginTop: '4px'
              }}>
                {filteredClients.map(client => (
                  <div
                    key={client.id}
                    onClick={() => handleSelectClient(client)}
                    style={{
                      padding: '10px 12px',
                      fontSize: '14px',
                      color: '#202124',
                      cursor: 'pointer',
                      backgroundColor: String(client.id) === String(form.clientId) ? '#e8f0fe' : 'transparent',
                      borderBottom: '1px solid #f1f3f4'
                    }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = '#f8f9fa'; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = String(client.id) === String(form.clientId) ? '#e8f0fe' : 'transparent'; }}
                  >
                    {client.label}
                  </div>
                ))}
              </div>
            )}
            {showDropdown && searchTerm && filteredClients.length === 0 && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: '#fff',
                border: '1px solid #dadce0',
                borderRadius: '4px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                padding: '12px',
                marginTop: '4px',
                fontSize: '14px',
                color: '#5f6368',
                textAlign: 'center',
                zIndex: 10
              }}>
                Aucun client trouvé
              </div>
            )}
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#5f6368' }}>
              Description *
            </label>
            <input
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: '14px',
                border: '1px solid #dadce0',
                borderRadius: '4px',
                backgroundColor: '#fff',
                color: '#202124'
              }}
              value={form.description}
              onChange={e => handleChange('description', e.target.value)}
              placeholder={type === 'broutille' ? 'Ex: Rachat or' : 'Ex: Retour avoir 123'}
              required
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#5f6368' }}>
              Date de saisie *
            </label>
            <input
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: '14px',
                border: '1px solid #dadce0',
                borderRadius: '4px',
                backgroundColor: '#fff',
                color: '#202124'
              }}
              type="date"
              value={form.dateSaisie}
              onChange={e => handleChange('dateSaisie', e.target.value)}
              required
            />
          </div>

          <div style={{ display: 'flex', gap: '16px', marginBottom: '20px' }}>
            {type === 'broutille' ? (
              <>
                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#5f6368' }}>
                    Poids brut (g) *
                  </label>
                  <input
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      fontSize: '14px',
                      border: '1px solid #dadce0',
                      borderRadius: '4px',
                      backgroundColor: '#fff',
                      color: '#202124'
                    }}
                    type="number"
                    step="0.01"
                    value={form.poidsBrut}
                    onChange={e => handleChange('poidsBrut', e.target.value)}
                    required
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#5f6368' }}>
                    Perte (%)
                  </label>
                  <input
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      fontSize: '14px',
                      border: '1px solid #dadce0',
                      borderRadius: '4px',
                      backgroundColor: '#fff',
                      color: '#202124'
                    }}
                    type="number"
                    step="0.01"
                    value={form.perte}
                    onChange={e => handleChange('perte', e.target.value)}
                  />
                </div>
              </>
            ) : (
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#5f6368' }}>
                  Poids or 750 (g) *
                </label>
                <input
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid #dadce0',
                    borderRadius: '4px',
                    backgroundColor: '#fff',
                    color: '#202124'
                  }}
                  type="number"
                  step="0.01"
                  value={form.poids750}
                  onChange={e => handleChange('poids750', e.target.value)}
                  required
                />
              </div>
            )}
          </div>

          {type === 'broutille' && form.poids750 && (
            <div style={{ marginBottom: '20px', padding: '12px', backgroundColor: '#e8f0fe', borderRadius: '4px' }}>
              <span style={{ fontSize: '14px', color: '#1967d2', fontWeight: 500 }}>
                Poids 750 après perte: {form.poids750} g
              </span>
            </div>
          )}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', paddingTop: '8px' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '8px 16px',
                fontSize: '14px',
                fontWeight: 500,
                color: '#5f6368',
                backgroundColor: '#fff',
                border: '1px solid #dadce0',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={posting}
              style={{
                padding: '8px 24px',
                fontSize: '14px',
                fontWeight: 500,
                color: '#fff',
                backgroundColor: posting ? '#80868b' : '#1a73e8',
                border: 'none',
                borderRadius: '4px',
                cursor: posting ? 'not-allowed' : 'pointer'
              }}
            >
              {posting ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OperationModal;
